// removed by extract-text-webpack-plugin
module.exports = {"backBox":"_2D_1F2GXCzNjqEsK6KkIvX_0","svg":"_2y5bfIp0gIDfnGpt5DS6xB_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-395a46da","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/common/BaseBack.vue
// module id = bEUT
// module chunks = 4